"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiuggi": {
    "96421f3d": [{
      "hkey": "4937af00",
      "slug": "fiuggi",
      "name": "Fiuggi",
      "primary": true,
      "skipSearch": false
    }],
    "cimetta": [{
      "hkey": "4937af00",
      "slug": "fiuggi",
      "name": "Fiuggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61fd1277": [{
      "hkey": "4937af00",
      "slug": "fiuggi",
      "name": "Fiuggi",
      "primary": true,
      "skipSearch": false
    }],
    "fonte": [{
      "hkey": "4937af00",
      "slug": "fiuggi",
      "name": "Fiuggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;